import Logo from "@/components/Logo";
import { SUPPORT_EMAIL } from "@/lib/links";

export default function Footer() {
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="wrap footer-inner">
        <a className="logo logo-link" href="#top" aria-label="ThinkWire home">
          <Logo size={22} />
        </a>
        <span>Live call assistance · Conversation intelligence · Follow-through</span>
        <a href={`mailto:${SUPPORT_EMAIL}`} data-testid="footer-email">
          {SUPPORT_EMAIL}
        </a>
        <span>© {new Date().getFullYear()} ThinkWire Inc.</span>
      </div>
    </footer>
  );
}
